import Immutable from 'immutable'
import moment from 'moment'
import { push } from 'react-router-redux'
import { devEnv, stateGetIn, apiHandleStatus } from '../../lib/index'

import CONSTANTS from '../../constants/constants'

import LoginReducer from '../login/reducer'
import capiSingleton from '../../api/carrotApi'
import { CarrotHelper } from '../../api/carrotApi'
const capi = capiSingleton.get()

const TYPES = {
    SET_LOADING: 'MAIN_SET_LOADING',
    SET_ENVIRONMENT: 'MAIN_SET_ENVIRONMENT',
    SET_AUTHENTICATION: 'MAIN_SET_AUTHENTICATION',

    SET_IDENTITIES_LOADING: 'MAIN_USER_SET_IDENTITIES_LOADING',
    SET_IDENTITIES: 'MAIN_USER_SET_IDENTITIES',
    SWITCH_CURRENT_IDENTITY: 'MAIN_USER_SWITCH_CURRENT_IDENTITY',
    SET_CURRENT_IDENTITY: 'MAIN_USER_SET_CURRENT_IDENTITY',
    SET_IDENTITIES_ERROR: 'MAIN_USER_SET_IDENTITIES_ERROR',

    SET_PROFILE_LOADING: 'MAIN_USER_SET_PROFILE_LOADING',
    SET_PROFILE: 'MAIN_USER_SET_PROFILE',
    SET_PROFILE_AND_CREDS: 'MAIN_USER_SET_PROFILE_AND_CREDS',
    SET_PROFILE_ERROR: 'MAIN_USER_SET_PROFILE_ERROR',

    SET_USER_SETTINGS: 'MAIN_USER_SET_USER_SETTINGS',
    SET_USER_ENDPOINTS: 'MAIN_USER_SET_USER_ENDPOINTS',
    LOGOUT: 'MAIN_USER_LOGOUT'
}

const INITIAL_USER_SETTINGS = {
    carrotUser      : false,
    carrotChoice    : false,
    adminOverride   : false,
    debug           : false,
    credentialSetOn : null,
    version         : 20210216
}

export default class MainReducer {
    static componentName = 'MainReducer'
    static NAME = 'main_reducer'
    static TYPES = TYPES
    static INITIAL_USER_SETTINGS = INITIAL_USER_SETTINGS
    static INITIAL_STATE = Immutable.fromJS({
        isLoading: false,
        isAuthenicated: false
    })

    static recursiveLambda(a, bs) {
        for (var b in bs) {
            if (!bs.hasOwnProperty(b)) continue

            if ('object' === typeof bs[b] && 'undefined' !== typeof a[b])
                a[b] = this.recursiveLambda(a[b], bs[b])
            else a[b] = bs[b];
        }

        return a;
    }

    static logout() {
        return (dispatch, getState) => {
            dispatch({ type: TYPES.LOGOUT })
            dispatch(push('/login'))
        }
    }

    static setLoading(
        isLoading
    ) {
        return (dispatch, getState) => dispatch({
            type: TYPES.SET_LOADING,
            isLoading
        })
    }

    static setEnvironment() {
        return (dispatch, getState) => dispatch({
            type: TYPES.SET_ENVIRONMENT,
            environment: capi.options.api_target
        })
    }

    static setAuthenicated(
        isAuthenicated
    ) {
        return (dispatch, getState) => dispatch({
            type: TYPES.SET_AUTHENTICATION,
            isAuthenicated
        })
    }

    static setIdentitiesLoading() {
        return (dispatch, getState) => dispatch({
            type: TYPES.SET_IDENTITIES_LOADING
        })
    }

    static setIdentities(
        identities
    ){
        return (dispatch, getState) => {
            const state = getState()
            const currentIdentityId = state[this.NAME].getIn(['user', 'credentials', 'current_identity'])
            const currentIdentity = identities.find((identity) => identity.id === currentIdentityId)
            const superUser = identities.find((identity) => CONSTANTS.USER_TYPES.SUPERUSER === identity.identity_type)

            if ( superUser ) dispatch(MainReducer.setProfileSettings({ carrotUser: true }))
            dispatch(MainReducer.setCurrentIdentity(currentIdentity))

            dispatch({
                type: TYPES.SET_IDENTITIES,
                identities
            })
        }
    }

    static setBusinessIdentity(
        identities
    ) {
        return (dispatch, getState) => {
            const businessIdentity = identities.find((identity) => CONSTANTS.USER_TYPES.ESTABLISHMENT === identity.identity_type)
            const superUser = identities.find((identity) => CONSTANTS.USER_TYPES.SUPERUSER === identity.identity_type)
            const currentBusinessIdentity = 'undefined' !== typeof businessIdentity
                                                ? businessIdentity
                                                : superUser

            if ( superUser ) dispatch(MainReducer.setProfileSettings({ carrotUser: true }))
            dispatch({ type: TYPES.SET_IDENTITIES, identities})

            if (
                'undefined' === typeof currentBusinessIdentity ||
                null === currentBusinessIdentity
            ) {
                dispatch(LoginReducer.setNoBusinessError('No Available Business'))
            } else {
                dispatch(MainReducer.switchCurrentIdentity(currentBusinessIdentity))
                dispatch(MainReducer.fetchEndpoints())
                dispatch(LoginReducer.setLoading(false))
                dispatch(push('/'))
                dispatch(LoginReducer.clear())
            }
        }
    }

    static switchCurrentIdentity(
        identity
    ) {
        return (dispatch, getState) => {
            const state = getState()
            let credentials = state[this.NAME].getIn(['user', 'credentials']).toJS()
            credentials['current_identity'] = identity.id
            credentials['current_identity_type'] = identity.identity_type

            dispatch(MainReducer.setCurrentIdentity(identity))

            dispatch({
                type: TYPES.SWITCH_CURRENT_IDENTITY,
                credentials
            })
        }
    }

    static setCurrentIdentity(
        currentIdentity
    ){
        return (dispatch, getState) => {
            dispatch({
                type: TYPES.SET_CURRENT_IDENTITY,
                currentIdentity
            })
        }
    }

    static setIdentitiesError(
        error
    ) {
        return (dispatch, getState) => dispatch({
            type: TYPES.SET_IDENTITIES_ERROR,
            error
        })
    }

    static setProfileLoading() {
        return (dispatch, getState) => dispatch({
            type: TYPES.SET_PROFILE_LOADING
        })
    }

    static setProfile(
        profile
    ) {
        return (dispatch, getState) => {
            dispatch({
                type: TYPES.SET_PROFILE,
                profile
            })
        }
    }

    static setProfileAndCreds(
        profile,
        credentials,
        settings
    ) {
        return (dispatch, getState) => dispatch({
            type: TYPES.SET_PROFILE_AND_CREDS,
            profile: profile,
            credentials: credentials,
            userSettings: settings
                            ? this.recursiveLambda(INITIAL_USER_SETTINGS, settings)
                            : INITIAL_USER_SETTINGS
        })
    }

    static setProfileError(
        error
    ) {
        return (dispatch, getState) => dispatch({
            type: TYPES.SET_PROFILE_ERROR,
            error
        })
    }

    static setProfileEndpoints(
        endpoints
    ) {
        return (dispatch, getState) => {
            dispatch({
                type: TYPES.SET_USER_ENDPOINTS,
                endpoints
            })
        }
    }

    static setProfileSettings(
        settings
    ) {
        return (dispatch, getState) => {
            const state = getState()
            let userSettings = state[this.NAME].getIn(['user', 'userSettings']).toJS()

            dispatch({
                type: TYPES.SET_USER_SETTINGS,
                userSettings: this.recursiveLambda(userSettings, settings)
            })
        }
    }

    static resetProfileSettings() {
        return (dispatch, getState) => {
            const state = getState();
            let userSettings = state[this.NAME].getIn(['user', 'userSettings']).toJS()

            let initial = this.recursiveLambda(INITIAL_USER_SETTINGS, userSettings)
            initial.version = INITIAL_USER_SETTINGS.version

            dispatch({
                type: TYPES.SET_USER_SETTINGS,
                userSettings: initial
            })
        }
    }

    static fetchIdentities() {
        return (dispatch, getState) => {
            dispatch(MainReducer.setIdentitiesLoading())

            capi.IdentitySwitcher.retrieve().then((res) => {
                apiHandleStatus(res, [200])

                dispatch(MainReducer.setIdentities(res.data))
            }).catch((error) => {
                dispatch(MainReducer.setIdentitiesError(error.message))
            })
        }
    }

    static fetchProfile(
        refresh = false
    ) {
        return (dispatch, getState) => {
            const state = getState()

            if (!refresh) {
                const profileSetOn = stateGetIn(state, this.NAME, ['user', 'profile', 'setOn'], 'MainReducer')
                if (moment(profileSetOn).add(CONSTANTS.INTERVAL_CACHING.SEC, 'seconds').isSameOrAfter(moment())) {
                    // profile was fetched recently, do nothing
                    devEnv() && console.log('Profile was fetched recently, doing nothing')
                    return
                }
            }

            dispatch(MainReducer.setProfileLoading())

            capi.User.retrieve().then((res) => {
                apiHandleStatus(res, [200])

                dispatch(MainReducer.setProfile(res.data))
            }).catch((error) => {
                dispatch(MainReducer.setProfileError(error.message))
            })
        }
    }

    static fetchEndpoints() {
        return (dispatch, getState) => {
            dispatch(MainReducer.setProfileLoading())

            capi.Endpoint.retrieve().then((res) => {
                apiHandleStatus(res, [200])

                dispatch(MainReducer.setProfileEndpoints(res.data))
            }).catch((error) => {
                dispatch(MainReducer.setProfileError(error.message))
            })
        }
    }

    static reducer(
        state = MainReducer.INITIAL_STATE,
        action
    ) {
        if (state == null) state = MainReducer.INITIAL_STATE

        switch (action.type) {
            case 'persist/REHYDRATE':
                if (
                    action.payload != null &&
                    action.payload[MainReducer.NAME] != null &&
                    action.payload[MainReducer.NAME].get('user')
                ) {
                    const user = action.payload[MainReducer.NAME].get('user')

                    CarrotHelper.setCredentials(capi, user.get('credentials'))

                    // Perfect time to refresh token

                    devEnv() && console.log('user & credentials REHYDRATED:', user.toJS())
                }

                return state

            case TYPES.LOGOUT: {
                capi.invalidateCredentials()

                return MainReducer.INITIAL_STATE
            }

            case TYPES.SET_LOADING:
                return state.set('isLoading', action.isLoading)

            case TYPES.SET_ENVIRONMENT:
                return state.set('environment', action.environment)

            case TYPES.SET_AUTHENTICATION:
                return state.set('isAuthenicated', action.isAuthenicated)

            case TYPES.SET_IDENTITIES_LOADING:
                return state.set('identitiesLoading', true)

            case TYPES.SET_IDENTITIES:
                return state.delete('identitiesError')
                .delete('identitiesLoading')
                .setIn(['user', 'identities'], Immutable.fromJS(action.identities))

            case TYPES.SWITCH_CURRENT_IDENTITY: {
                let newState = state.setIn(['user', 'credentials', 'current_identity'], action.credentials.current_identity)
                .setIn(['user', 'credentials', 'current_identity_type'], action.credentials.current_identity_type)
                .setIn(['user', 'userSettings', 'carrotUser'], CONSTANTS.USER_TYPES.SUPERUSER === action.credentials.current_identity_type)

                if (CONSTANTS.USER_TYPES.SUPERUSER === action.credentials.current_identity_type) {
                    newState = newState.setIn(['user', 'userSettings', 'adminOverride'], true)
                }

                CarrotHelper.setCredentials(
                    capi,
                    action.credentials
                )

                return newState
            }

            case TYPES.SET_CURRENT_IDENTITY:
                return state.setIn(['user', 'currentIdentity'], Immutable.fromJS(action.currentIdentity))

            case TYPES.SET_IDENTITIES_ERROR:
                return state.set('identitiesError', action.error)

            case TYPES.SET_PROFILE_LOADING:
                return state.set('profileLoading', true)

            case TYPES.SET_PROFILE:
                return state.delete('profileError')
                    .delete('profileLoading')
                    .setIn(['user', 'profile'], Immutable.fromJS(action.profile))
                    .setIn(['user', 'profile', 'setOn'], new Date().getTime())

            case TYPES.SET_PROFILE_AND_CREDS: {
                let newState = state.delete('profileError')
                    .delete('profileLoading')
                    .set('isAuthenicated', true)
                    .setIn(['user', 'profile'], Immutable.fromJS(action.profile))
                    .setIn(['user', 'credentials'], Immutable.fromJS(action.credentials))
                    .setIn(['user', 'userSettings'], Immutable.fromJS(action.userSettings))
                    .setIn(['user', 'profile', 'setOn'], new Date().getTime())

                CarrotHelper.setCredentials(
                    capi,
                    action.credentials
                )

                return newState
            }

            case TYPES.SET_PROFILE_ERROR:
                return state.set('profileError', action.error)

            case TYPES.SET_USER_ENDPOINTS:
                return state.delete('profileError')
                    .delete('profileLoading')
                    .setIn(['user', 'endpoints'], Immutable.fromJS(action.endpoints))

            case TYPES.SET_USER_SETTINGS:
                return state.setIn(['user', 'userSettings'], Immutable.fromJS(action.userSettings))

            default:
                return state
        }
    }
}



// WEBPACK FOOTER //
// ./src/containers/main/reducer.js